import { Button } from '@mui/joy';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';

export function AddNavigationButton({ onClick, disabled, to }) {
  return (
    <Button variant="solid" color="primary" disabled={disabled} component={to ? Link : Button} to={to} sx={{
      borderRadius: '50%',
      border: 'none',
      boxShadow: '0 8px 18px rgba(43,79,214,.36)',
      width: '54px',
      height: '54px',
      mt: -4.5,
    }} onClick={onClick}>
      <AddIcon sx={{ fontSize: '26px' }} />
    </Button>
  );
}